import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/datenschutz')({
  loader: () =>
    loadPageData({
      data: { kind: 'legal', locale: 'de', params: { legalKind: 'datenschutz' } },
    }),
  head: () => staticRouteHead('privacy', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <LegalPage kind="datenschutz" />
    </CatalogProvider>
  )
}
